var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.75 7.70096C14.75 8.27831 14.75 9.72169 13.75 10.299L3.25 16.3612C2.25 16.9386 1 16.2169 1 15.0622L1 2.93782C1 1.78312 2.25 1.06143 3.25 1.63878L13.75 7.70096Z","stroke":"white"}));
}

PlayIconInline.defaultProps = {"width":"15","height":"18","viewBox":"0 0 15 18","fill":"none"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
